import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center z-index-1 w-100" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "INCLUSION IMPACT INDEX", -1)
const _hoisted_6 = ["alt"]
const _hoisted_7 = {
  key: 0,
  class: "bg-white rounded p-5 print-pt-0"
}
const _hoisted_8 = { class: "pdf-item" }
const _hoisted_9 = { class: "pt-3" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "my-5" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 3,
  class: "border-top border-dark p-3 mt-5"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_17 = {
  class: "mt-2",
  style: {"font-weight":"400"}
}
const _hoisted_18 = { class: "text-center py-5" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_20 = { class: "px-5" }
const _hoisted_21 = { class: "h5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "#", -1)
const _hoisted_23 = { class: "h5 px-5" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "border-end border-start border-dark px-10 px-5" }, " # ", -1)
const _hoisted_25 = { class: "px-5" }
const _hoisted_26 = { class: "h5" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "#", -1)
const _hoisted_28 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_29 = { class: "h5 px-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "px-5" }, "#", -1)
const _hoisted_31 = { class: "h5 px-5" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "border-start border-dark px-10 px-5" }, "#", -1)
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { class: "h5" }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { class: "h5" }
const _hoisted_37 = { key: 4 }
const _hoisted_38 = { class: "h5" }
const _hoisted_39 = { key: 5 }
const _hoisted_40 = { class: "h5" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, "##%", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: "/media/logos/iii-logo.png",
          alt: _ctx.translate('III_PLUS_LOGO'),
          class: "h-100"
        }, null, 8, _hoisted_4),
        _hoisted_5
      ]),
      _createElementVNode("img", {
        src: "/media/logos/bottom_logo.png",
        class: "h-50px",
        alt: _ctx.translate('VALORED_PROJECT_LOGO')
      }, null, 8, _hoisted_6)
    ]),
    (_ctx.surveyHeaderList.length > 0 && _ctx.getSurveyStructureList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSurveyStructureList, (stepList, index) => {
            return (_openBlock(), _createElementBlock("section", {
              slot: "pdf-content",
              class: "survey-structure",
              key: index
            }, [
              _createElementVNode("section", _hoisted_8, [
                _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.surveyStepList[index][_ctx.translateKey("descrizione")]), 1),
                _createElementVNode("div", {
                  class: "fw-bold fs-6 py-5",
                  innerHTML: _ctx.translate(_ctx.messages_survey[index])
                }, null, 8, _hoisted_10)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepList, (item, itemIndex) => {
                return (_openBlock(), _createElementBlock("section", {
                  class: "pdf-item",
                  key: itemIndex
                }, [
                  (_ctx.getHeader(item.auto_number))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.getHeader(item.auto_number)[_ctx.translateKey("message")]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (item.auto_number == 76)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "text-gray-600 fw-bold fs-6 mt-5",
                        innerHTML: _ctx.translate('SURVEY_1_MESSAGE_COMPOSIZIONE_DIPENDENTI_STAFF_LINEA')
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  (item.auto_number == 163)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "text-gray-600 fw-bold fs-6 mt-5",
                        innerHTML: _ctx.translate('SURVEY_9_MESSAGE_CONGEDO_PARENTALE_PER_GENERE')
                      }, null, 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  (item.sub_id == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("h5", _hoisted_17, _toDisplayString(item.set_id) + "." + _toDisplayString(item.id) + " " + _toDisplayString(item[_ctx.translateKey("name")]), 1),
                        _createElementVNode("div", _hoisted_18, [
                          (item.type == 'IntegerGenderField')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1),
                                  _hoisted_22
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
                                  _hoisted_24
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.translate("SURVEY_TOTAL_STRING")), 1),
                                  _hoisted_27
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (item.type == 'FloatGenderField')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1),
                                  _hoisted_30
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
                                  _hoisted_32
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (item.type == 'RoleGenderField')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.translate("SURVEY_SUMMARY_GENDER_STRING")), 1),
                                _createElementVNode("p", null, " (" + _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")) + "/" + _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")) + ") ", 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.type == 'SelectYesNoField')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.translate("SURVEY_SUMMARY_ANSWER_STRING")), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.translate("SURVEY_STRUCTURE_SUMMARY_YES_NO_ALTERNATIVES")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.type == 'TextAreaField')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.translate("SURVEY_TEXTAREA_LABEL")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.type == 'PercentageField')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.translate("SURVEY_TOTAL_STRING")), 1),
                                _hoisted_41
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}